import React, { useState, useEffect } from "react";
import { db } from "../../../Firebase";
import { collection, getDocs } from "firebase/firestore";
import { Pagination } from "@material-ui/lab";
import {
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  ThemeProvider,
  createTheme,
  makeStyles,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { CryptoState } from "../../../CryptoContext";

const AdminData = () => {
  const [adminData, setAdminData] = useState([]);
  const { loading } = CryptoState();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const useStyles = makeStyles({
    row: {
      backgroundColor: "#16171a",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#131111",
      },
      fontFamily: "Open Sans",
    },
    pagination: {
      "& .MuiPaginationItem-root": {
        color: "orange",
      },
    },
    paper: {
      margin: "auto",
      marginTop: 30,
      width: "85%",
    },
  });

  const handleSearch = () => {
    return adminData.filter(
      (user) =>
        (user.names || "").toLowerCase().includes(search.toLowerCase()) ||
        user.id.toLowerCase().includes(search.toLowerCase())
    );
  };

  useEffect(() => {
    const getAdmin = async () => {
      let list = [];
      try {
        const adminSnapshot = await getDocs(collection(db, "admins"));
        adminSnapshot.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setAdminData(list);
      } catch (error) {
        console.error("Error getting admins:", error);
      }
    };
    getAdmin();
  }, []);

  const darkTheme = createTheme({
    palette: {
      primary: { main: "#fff" },
      type: "dark",
    },
  });

  const classes = useStyles();

  return (
    <ThemeProvider theme={darkTheme}>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Search style={{ margin: "45px 10px 0 0" }} />
        <TextField
          label="Search Admin by Name or ID"
          variant="outlined"
          style={{
            marginBottom: 25,
            marginTop: 30,
            width: "45%",
            minWidth: "300px",
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <TableContainer component={Paper} className={classes.paper}>
        {loading ? (
          <LinearProgress style={{ backgroundColor: "orange" }} />
        ) : (
          <Table aria-label="simple table">
            <TableHead style={{ backgroundColor: "orange" }}>
              <TableRow>
                {["Admin ID", "Name"].map((head) => (
                  <TableCell
                    style={{
                      color: "black",
                      fontWeight: "700",
                      fontSize: "22px",
                      fontFamily: "Open Sans",
                    }}
                    key={head}
                    align={head === "Admin ID" ? "left" : "right"}
                  >
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {handleSearch()
                .slice((page - 1) * 10, (page - 1) * 10 + 10)
                .map((user) => {
                  return (
                    <TableRow className={classes.row} key={user.id}>
                      <TableCell component="th" scope="row">
                        {user.id}
                      </TableCell>
                      <TableCell align="right">{user.names}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        )}
      </TableContainer>

      <Pagination
        count={parseInt((handleSearch()?.length / 10).toFixed(0))}
        style={{
          padding: 20,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
        classes={{ ul: classes.pagination }}
        onChange={(_, value) => {
          setPage(value);
          window.scrollTo(0, 0);
        }}
      />
    </ThemeProvider>
  );
};

export default AdminData;
